import React, { useState } from "react";

const DashboardSearch = ({ setFilter, getSearchResult }) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [searchBy, setsearchBy] = useState("fileName");
  const [searchValue, setsearchValue] = useState("");

  const togglePopup = () => {
    setIsPopupOpen(!isPopupOpen);
  };

  const postFilters = () => {
    setFilter(searchValue);
    getSearchResult(searchValue); // Pass searchValue directly
    togglePopup();
  };

  const handleResetButtonClick = () => {
    setsearchBy("FileName");
    setsearchValue("");
  };

  return (
    <div>
      {/* Button to trigger popup */}
      <button className="btn searchBtn" onClick={togglePopup}>
        <i className="fa fa-search" aria-hidden="true"></i> Search
      </button>

      {/* Popup */}
      {isPopupOpen && (
        <div className="SerchPopupWrp">
          <h6 className="mt-3">Search by</h6>
          <div style={{ display: "flex", gap: 5 }}>
            <select
              className="form-select"
              style={{ width: "40%" }}
              value={searchBy}
              onChange={(e) => setsearchBy(e.target.value)}
            >
              <option value="fileName">FileName</option>
            </select>
            <input
              type="text"
              className="form-control"
              style={{ width: "60%" }}
              onChange={(e) => {
                setsearchValue(e.target.value);
              }}
              value={searchValue}
            />
          </div>

          <button
            onClick={postFilters}
            className="btn nextBtn"
            style={{ marginLeft: "0px", marginRight: "10px" }}
          >
            Apply
          </button>
          <button
            className="btn backBtn"
            onClick={handleResetButtonClick}
            style={{ marginTop: "20px" }}
          >
            Reset
          </button>
        </div>
      )}

      {/* Background overlay */}
      {isPopupOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            // backgroundColor: "rgba(255, 255, 255, 0.5)",
            zIndex: 999,
          }}
          onClick={togglePopup}
        ></div>
      )}
    </div>
  );
};

export default DashboardSearch;
